type TAuthFailureHandler = () => void | Promise<void>

let authFailureHandler: TAuthFailureHandler | null = null
let authFailureInFlight: Promise<void> | null = null

export function registerAuthFailureHandler(handler: TAuthFailureHandler) {
  authFailureHandler = handler
}

export function unregisterAuthFailureHandler() {
  authFailureHandler = null
}

export function isAuthFailureInProgress(): boolean {
  return authFailureInFlight !== null
}

/** Single-flight so concurrent 401s / session failures trigger one logout. */
export function notifyAuthFailure(): Promise<void> {
  if (!authFailureHandler) {
    return Promise.resolve()
  }

  if (!authFailureInFlight) {
    authFailureInFlight = Promise.resolve(authFailureHandler()).finally(() => {
      authFailureInFlight = null
    })
  }

  return authFailureInFlight
}
